<template>
  <div>
    <div :style="{backgroundImage: 'url('+require('../../assets/img/list-banners/'+ProductTypeDB+'.jpg')+')'}"
      class="products-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="white">
              Products - {{ProductType}}
            </h1>
            <p class="white no-bottom">Click on the product image or title to view more details about the product.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container section-padding smaller-section-padding">
      <div v-if="processing">
        <div class="row space-loader d-flex align-items-center justify-content-center">
          <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
        </div>
      </div>
        <div v-else class="row">
          <div class="row" v-if="isEmpty">
            <div class="col-lg-4 offset-lg-4 center">
              <img class="empty img-fluid" src="@/assets/img/empty.svg" />
              <h2 class="space-top">No Products Found</h2>
              <p style="opacity:.7">
                No items have been listed under the category {{ProductType}}. Be sure to check back later when we have more items in stock!
              </p>
            </div>
          </div>
          <ProductCard v-else  v-for="(product, productIndex) in products" :key="productIndex" v-bind:product="product" />
        </div>
    </div>
    <div class="homepage-contact relative ">
      <div class="container homepage-contact-padding">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="space-bottom white">Contact Us For More Info</h2>
            <p class="white no-bottom">
             Click the button to visit our contact page if you need to get ahold of us for more informaion.
            </p>
          </div>
          <div class="col-lg-6 d-flex align-items-center justify-content-lg-end">
            <router-link to="/contact">
              <div class="button-container space-top-ipad">
                <div class="standard-button d-flex flex-row">
                  <div class="cart-left d-flex align-items-center">
                    <p>Contact Us</p>
                  </div>
                  <div class="cart-right d-flex align-items-center justify-content-center">
                    <ArrowRightIcon :size="100" fillColor="rgb(255,255,255)" />
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductCard from "@/components/ProductCard.vue";
  import api from "../../api/api";
  import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';

  export default {
    components: {
      ProductCard,
      ArrowRightIcon
    },
    data: function () {
      return {
        backgroundImg: "default",
        products: {},
        page: 0,
        processing: true,
        isEmpty: false
      };
    },
    computed: {
      ProductType: function () {
        switch (this.$route.params.type) {
          case "cars":
            return "Cars";
          case "electronics":
            return "Electronics";
          case "engines":
            console.log( this.$route.query.type.charAt(0).toUpperCase() +
              this.$route.query.type.slice(1) +
              "Engines"+'.jpg')
            return (
              this.$route.query.type.charAt(0).toUpperCase() +
              this.$route.query.type.slice(1) +
              " Engines"
            );
          case "helicopters":
            return "Helicopters";
          case "kits":
            return "Kits";
          case "planes":
            return "Planes";
          case "spares":
            return "Spares";
          case "steam":
            return "Steam";
          case "tools":
            return "Tools";
          case "trains":
            return "Trains";
        }
        return "Bad Type";
      },
      ProductTypeDB: function () {
        switch (this.$route.params.type) {
          case "cars":
            return "car";
          case "electronics":
            return "electronic";
          case "engines":
            return "engine";
          case "helicopters":
            return "helicopter";
          case "kits":
            return "kit";
          case "planes":
            return "plane";
          case "spares":
            return "spare";
          case "steam":
            return "steam";
          case "tools":
            return "tool";
          case "trains":
            return "train";
        }
        return "Bad Type";
      },
    },
    mounted() {
      this.loadProducts();
    },
    watch: {
      $route() {
        this.loadProducts();
      },
    },
    methods: {
      runStupid() {
        return this.ProductType.replace(/ /g, ""); 
      },
      loadProducts() {
        this.products = {};
        this.processing = true;
        var metadata = "";
        if (this.$route.query.type != undefined)
          metadata = `"engine_type":"${this.$route.query.type}"`;
        api
          .getProductsByTypeAndStatus(
            this.ProductTypeDB,
            "listed",
            0,
            0,
            metadata
          )
          .then((res) => {
            for (var i = 0; i < res.products.length; i++) {
              this.$set(this.products, res.products[i].id, res.products[i]);
            
            }
             console.log(this.ProductTypeDB)
          })
          // .catch((err) => {
          //   console.log(err);
          // })
          .finally(() => {
            this.processing = false;
            if(Object.keys(this.products).length == 0){
              this.isEmpty = true
            } else {
              this.isEmpty = false
            }
          });
      },
    },
  };
</script>